import React from 'react';

const BusinessForum = () => {
  return (
    <div>
      <section className="page-hero">
        <h1>Business & Investment Forum</h1>
        <p>Connecting investors with African opportunities</p>
      </section>
      <section className="page-content">
        <div className="container">
          <div className="content-grid">
            <div className="content-card">
              <h2>International Forum</h2>
              <p>Global investment networking events.</p>
              <button className="btn-gold" onClick={() => window.location.href='/international-forum'}>Learn More</button>
            </div>
            <div className="content-card">
              <h2>Membership Benefits</h2>
              <p>Exclusive benefits for forum members.</p>
              <button className="btn-gold" onClick={() => window.location.href='/membership-benefits'}>View Benefits</button>
            </div>
            <div className="content-card">
              <h2>Members Showcase</h2>
              <p>Highlighting our distinguished members.</p>
              <button className="btn-gold" onClick={() => window.location.href='/members-showcase'}>View Showcase</button>
            </div>
            <div className="content-card">
              <h2>Become a Member</h2>
              <p>Join the forum today.</p>
              <button className="btn-gold" onClick={() => window.location.href='/become-member'}>Join Now</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BusinessForum;